export  default {
    getLogRequests(state) {
        return state.logRequests;
    },
};